import { MenuItem, TextField, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';

interface IFormSelectProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  error: string;
  value: string;
  placeholder: string;
  label: string;
  required?: boolean;
  name: string;
  options: { id: number; name: string; value: string }[];
}
const FormSelect: React.FC<IFormSelectProps> = ({
  onChange,
  error,
  value,
  label,
  required,
  name,
  placeholder,
  options,
}) => {
  return (
    <Stack gap={'7px'} sx={{ minHeight: '100px' }}>
      <Typography variant="h3">
        {label}{' '}
        {required && (
          <Box component={'span'} sx={{ color: 'red' }}>
            *
          </Box>
        )}
      </Typography>
      <TextField
        onChange={onChange}
        size={'small'}
        error={Boolean(error)}
        helperText={error || ''}
        name={name}
        value={value || ''}
        // label={placeholder}
        select
      >
        {options.map(({ id, name, value }) => (
          <MenuItem key={id} value={value}>
            {name}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
};

export default FormSelect;
